import React, { useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { PrimaryButton, SecondaryButton } from "@loanbossinc/component-library";
import _ from "lodash";

import { getCompanyTypes, getCompanyLevels } from "../../../store/state/companies";

import AppCard from "./AppCard";
import "./style.css";
import { getCanEdit, getApps, saveApps, activateApp, deactivateApp, setAppLogo } from "./appsSettings.store";
import EditAppsAdminsDrawer from "./EditAppsAdminsDrawer";

const PageTitle = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #000000;
  margin-bottom: 15px;
  margin-left: 23px;
`;

export const PageDescription = styled.div`
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #000000;
  opacity: 0.6;
`;

const AppsSettings = ({
  getCanEdit,
  getApps,
  getCompanyTypes,
  getCompanyLevels,
  canEdit,
  apps = [],
  companyTypes,
  companyLevels,
  saveApps,
  activateApp,
  deactivateApp,
  setAppLogo,
  history
}) => {
  useEffect(() => {
    getCanEdit();
    getApps();
    getCompanyTypes();
    getCompanyLevels();
  }, []);

  const [editAdminsVisible, setEditAdminsVisible] = useState(false);

  return (
    <div style={{ width: "1200px" }}>
      <Grid container direction="row" justify="space-between" alignItems="center" style={{ marginBottom: "20px" }}>
        <Grid item>
          <PageTitle>Apps Settings</PageTitle>
          <PageDescription style={{ marginLeft: "23px" }}>Update App Settings and Information using the settings below.</PageDescription>
        </Grid>
        <Grid item>
          <SecondaryButton label="Edit Admins" size="sm-fluid" style={{ marginRight: "10px", border: "0" }} onClick={() => setEditAdminsVisible(true)} />
          <PrimaryButton label="Save" size="sm" onClick={() => saveApps(apps)} disabled={!apps || !canEdit} />
        </Grid>
      </Grid>
      <div>
        {companyTypes?.length > 0 &&
          companyLevels?.length > 0 &&
          apps?.map(app => <AppCard
            key={app.id}
            app={app}
            companyTypes={companyTypes}
            companyLevels={companyLevels}
            disabled={!canEdit}
            onActivate={() => activateApp(app.id)}
            onDeactivate={() => deactivateApp(app.id)}
            onSetLogo={file => setAppLogo({ appId: app.id, file })}
            history={history}
          />)}
      </div>
      {editAdminsVisible && <EditAppsAdminsDrawer onClose={() => setEditAdminsVisible(false)} disabled={!canEdit} />}
    </div>
  );
};

const mapStateToProps = ({ appSettings, companies }) => ({
  apps: _.sortBy(appSettings.apps, ["name"]),
  canEdit: appSettings.canEdit,
  companyTypes: _.sortBy(companies.companyTypes, ["name"]),
  companyLevels: _.sortBy(companies.companyLevels, ["label"])
});

export default compose(
  connect(
    mapStateToProps,
    {
      getCanEdit,
      getApps,
      saveApps,
      setAppLogo,
      getCompanyTypes,
      getCompanyLevels,
      activateApp,
      deactivateApp
    }
  )
)(AppsSettings);
